import api from "../api";

export const permissionsService = {
  listPermissions: async (accountId) => {
    const res = await api.get(`/api/v2/permissions/`, { params: { account_id: accountId } });
    return Array.isArray(res.data) ? res.data : [];
  },

  createPermission: async ({ codename, name, description, account_id }) => {
    const res = await api.post(`/api/v2/permissions/`, { codename, name, description, account_id });
    return res.data;
  },

  deletePermission: async (permId, accountId) => {
    await api.delete(`/api/v2/permissions/${permId}/`, { params: { account_id: accountId } });
  },

  listGroups: async (accountId) => {
    const res = await api.get(`/api/v2/permissions/groups/`, { params: { account_id: accountId } });
    return Array.isArray(res.data) ? res.data : [];
  },

  createGroup: async ({ name, description, account_id, permission_ids }) => {
    const res = await api.post(`/api/v2/permissions/groups/`, { name, description, account_id, permission_ids });
    return res.data;
  },

  getGroup: async (groupId) => {
    const res = await api.get(`/api/v2/permissions/groups/${groupId}/`);
    return res.data;
  },

  updateGroup: async (groupId, payload) => {
    const res = await api.patch(`/api/v2/permissions/groups/${groupId}/`, payload);
    return res.data;
  },

  deleteGroup: async (groupId) => {
    await api.delete(`/api/v2/permissions/groups/${groupId}/`);
  },

  getUserAccount: async (uaId) => {
    const res = await api.get(`/api/v2/permissions/user-accounts/${uaId}/`);
    return res.data;
  },

  findUserAccount: async (userId, accountId) => {
    const res = await api.get(`/api/v2/permissions/user-accounts/`, {
      params: { user_id: userId, account_id: accountId },
    });
    if (Array.isArray(res.data)) return res.data[0] ?? null;
    if (Array.isArray(res.data?.results)) return res.data.results[0] ?? null;
    return res.data ?? null;
  },

  assignPermission: async (uaId, { permission_id, expires_at }) => {
    const body = { permission_id };
    if (expires_at) body.expires_at = expires_at;
    const res = await api.post(`/api/v2/permissions/user-accounts/${uaId}/assign-permission/`, body);
    return res.data;
  },

  revokePermission: async (uaId, permId) => {
    await api.delete(`/api/v2/permissions/user-accounts/${uaId}/permissions/${permId}/`);
  },

  assignGroup: async (uaId, { group_id, expires_at }) => {
    const body = { group_id };
    if (expires_at) body.expires_at = expires_at;
    const res = await api.post(`/api/v2/permissions/user-accounts/${uaId}/assign-group/`, body);
    return res.data;
  },

  removeFromGroup: async (uaId, groupId) => {
    await api.delete(`/api/v2/permissions/user-accounts/${uaId}/groups/${groupId}/`);
  },
};
